import { render, staticRenderFns } from "./InvestorForm.vue?vue&type=template&id=41bdb406"
import script from "./InvestorForm.vue?vue&type=script&lang=js"
export * from "./InvestorForm.vue?vue&type=script&lang=js"
import style0 from "./InvestorForm.vue?vue&type=style&index=0&id=41bdb406&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports